import { z } from "zod";

export const ImportDataUploadResultSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  extension: z.string().optional(),
  sizeKb: z.number().optional(),
  objectName: z.string(),
});
